/**
 * Generate a password based on a line of dialogue
 * @param {string} text - Line of dialogue from the movie
 * @returns {string} Generated password
 */
export const generatePassword = (text: string): string => {
  const validChars = text.replace(/[^\w!?.,-]/g, " ");
  const words = validChars.split(/\s+/).filter((word) => word.length > 0);

  // Generate password components
  let password = "";

  for (let i = 0; i < words.length; i++) {
    // Add first character of each word
    if (words[i].length > 0) {
      password += words[i][0];
    }

    // Check if the word ends with a special character and add it
    const lastChar = words[i][words[i].length - 1];
    if (lastChar && ["!", "?", ".", ","].includes(lastChar)) {
      password += lastChar;
    }
  }

  const validPasswordChars = /[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
  password = password
    .split("")
    .filter((char) => validPasswordChars.test(char))
    .join("");

  return password;
};
